module.exports = __webpack_public_path__ + "static/media/checkpoint.e82ce0ca.png";